import {
  FieldText,
  FlexBox,
  IconButton,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

import styles from './variableRow.module.scss';

export const PATH_FIELD = 'path';
export const ID_FIELD = 'id';

interface Props {
  field: string;
  index: number;
  onRemove: (index: number) => void;
  variablesValue: {
    locked?: boolean;
  }[];
}

const CANT_DELETE_TIP = 'This variable is used later in the flow';

export function VariableRow({
  field,
  index,
  onRemove,
  variablesValue,
}: Props): JSX.Element {
  const cantDelete = variablesValue?.[index]?.locked;
  const tip = cantDelete ? CANT_DELETE_TIP : null;

  return (
    <FlexBox alignItems="center" justifyContent="space-between">
      <Field
        className={styles.field}
        component={FieldText}
        label="JSON path"
        name={`${field}.${PATH_FIELD}`}
        placeholder="Key"
        type="option"
      />
      <Tooltip content={tip} disabled={!cantDelete}>
        <Field
          className={styles.field}
          component={FieldText}
          disabled={cantDelete}
          label="Variable name"
          name={`${field}.${ID_FIELD}`}
          placeholder="Value"
          type="option"
        />
      </Tooltip>
      <Tooltip content={tip} disabled={!cantDelete}>
        <IconButton
          className={styles.trash}
          disabled={cantDelete}
          icon="trash"
          onClick={() => onRemove(index)}
          variant="tertiary"
        />
      </Tooltip>
    </FlexBox>
  );
}
